module.exports = __webpack_public_path__ + "img/shoot.905071f8.svg";